import React, { useEffect, useState } from 'react';
import { useMyContext } from '../MyContext';
import { FaEdit, FaTrash } from 'react-icons/fa';

const PromptManagementTab = () => {
  const {
    promptMaster,
    fetchPromptMaster,
    loading,
    error,
    updatePromptMaster,
    deletePromptMaster,
    addPromptMaster
  } = useMyContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const [editedPrompt, setEditedPrompt] = useState({ promptcategory: '', promptname: '' });
  const [newPrompt, setNewPrompt] = useState({ promptcategory: '', promptname: '' });

  useEffect(() => {
    fetchPromptMaster();
  }, []);

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditedPrompt(promptMaster[index]);
  };

  const handleUpdate = async () => {
    await updatePromptMaster(editedPrompt.promptcategory, editedPrompt.promptname);
    setEditIndex(null);
  };

  const handleDelete = async (category) => {
    await deletePromptMaster(category);
  };

  const handleAdd = async () => {
    await addPromptMaster(newPrompt.promptcategory, newPrompt.promptname);
    setNewPrompt({ promptcategory: '', promptname: '' });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredPrompts = (promptMaster || []).filter(
    (item) =>
      item.promptcategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.promptname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPrompts.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredPrompts.length / itemsPerPage);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Prompt Management</h2>

      {/* Add New Prompt */}
      <div className="mb-6 p-4 border border-gray-300 rounded bg-white">
        <h3 className="text-lg font-semibold mb-2">Add New Prompt</h3>
        <input
          type="text"
          placeholder="Prompt Category"
          value={newPrompt.promptcategory}
          onChange={(e) => setNewPrompt({ ...newPrompt, promptcategory: e.target.value })}
          className="mb-2 p-2 border border-gray-300 rounded w-full"
        />
        <textarea
          placeholder="Prompt Text"
          value={newPrompt.promptname}
          onChange={(e) => setNewPrompt({ ...newPrompt, promptname: e.target.value })}
          className="mb-2 p-2 border border-gray-300 rounded w-full"
          rows={2}
        />
        <button
          onClick={handleAdd}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add Prompt
        </button>
      </div>

      {/* Search */}
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Search by category or prompt text"
        className="mb-4 p-2 border border-gray-300 rounded w-full"
      />

      {loading && <p className="text-gray-600">Loading prompts...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {currentItems && currentItems.length > 0 ? (
        <table className="min-w-full bg-white border border-gray-300 shadow">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b">#</th>
              <th className="px-4 py-2 border-b text-left">Category</th>
              <th className="px-4 py-2 border-b text-left">Prompt Text</th>
              <th className="px-4 py-2 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 border-b">{indexOfFirstItem + index + 1}</td>
                <td className="px-4 py-2 border-b">
                  {editIndex === indexOfFirstItem + index ? (
                    <input
                      value={editedPrompt.promptcategory}
                      onChange={(e) => setEditedPrompt({ ...editedPrompt, promptcategory: e.target.value })}
                      className="border p-1 w-full"
                    />
                  ) : (
                    item.promptcategory
                  )}
                </td>
                <td className="px-4 py-2 border-b">
                  {editIndex === indexOfFirstItem + index ? (
                    <textarea
                      value={editedPrompt.promptname}
                      onChange={(e) => setEditedPrompt({ ...editedPrompt, promptname: e.target.value })}
                      className="border p-1 w-full"
                      rows={2}
                    />
                  ) : (
                    item.promptname
                  )}
                </td>
                <td className="px-4 py-2 border-b">
                  {editIndex === indexOfFirstItem + index ? (
                    <button
                      onClick={handleUpdate}
                      className="text-blue-600 hover:underline mr-2"
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      onClick={() => handleEdit(indexOfFirstItem + index)}
                      className="text-green-600 hover:text-green-800 mr-2"
                    >
                      <FaEdit />
                    </button>
                  )}
                  <button
                    onClick={() => handleDelete(item.promptcategory)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        !loading && <p className="text-gray-600">No prompts found.</p>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-4 space-x-2">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-500'}`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PromptManagementTab;

